  <form [formGroup]="labFormGroup">
  <div class="flex flex-col w-full">
    <div class="flex flex-row w-full">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-row w-full items-center">
          <div class="flex flex-row w-full">
            <div>
              <span style="font-weight:bold;">Created By: </span>
              <span>{{createdBy}} on {{createDate}}</span>
              <br />
              <span style="font-weight:bold;">Last Updated by: </span>
              <span>{{updatedBy}} on {{updateDate}}</span>
            </div>
            <div>
              <span *ngIf="editMode" class="oha-blue-bg p-x-48 text-light">Edit Mode</span>
            </div>
          </div>

          <div class="flex flex-row float-right">
            <button mat-icon-button *ngIf="!editMode" matTooltip="Print" (click)="printLabDemographics()"
              [matTooltipShowDelay]="750">
              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">printer</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!editMode && !labService.readonly" matTooltip="Edit" (click)="editLab()"
              [matTooltipShowDelay]="750">
              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">edit</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!isDirty && editMode" matTooltip="Save"
              (click)="saveLabDemographics()" [matTooltipShowDelay]="750">
              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
            </button>
            <button mat-icon-button *ngIf="editMode" matTooltip="Cancel" (click)="cancelLab()"
              [matTooltipShowDelay]="750">
              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
            </button>
          </div>
        </div>
      </mat-card>
    </div>

    <span style="width: 100%;border-top: 1px solid grey"></span>
    <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="1cm">

    <div class="flex flex-row gap-4 w-full">
      <div class="flex flex-row flex-wrap gap-4 sm:flex-col w-1/2">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <div class="flex flex-col mt-4">

                <mat-form-field>
                  <mat-label>Lab Name</mat-label>
                  <input matInput placeholder="Test Lab Name" formControlName="LabName">
                  <mat-error *ngIf="labFormGroup.get('LabName').invalid">
                    This field is required (66 char max)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>State Number</mat-label>
                  <input matInput
                    value="{{labFormGroup.get('CliaSchedule').value}} {{labFormGroup.get('StateNumber').value}}"
                    readonly>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>NPI</mat-label>
                  <input matInput formControlName="Upn">
                  <mat-error *ngIf="labFormGroup.get('Upn').invalid">
                    Cannot be longer than 10 characters.
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Certificate Type</mat-label>
                  <mat-select formControlName="CertificateType">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let types of certList" [value]="types.key">{{types.value}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="labFormGroup.get('CertificateType').invalid">
                    Certificate Type cannot be longer than 1 character
                  </mat-error>
                </mat-form-field>

                <mat-form-field [ngStyle]="{'background-color': (labFormGroup.controls['Closed'].value=='Y') ? 'tomato' : ''}" >
                  <mat-label>Closed</mat-label>
                  <mat-select formControlName="Closed">
                    <mat-option value=""></mat-option>
                    <mat-option value="Y">Yes</mat-option>
                    <mat-option value="N">No</mat-option>
                  </mat-select>
                  <mat-error *ngIf="labFormGroup.get('Closed').invalid">
                    Cannot be longer than 1 character
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Tax ID</mat-label>
                  <input matInput placeholder="Tax ID" formControlName="TaxId">
                  <mat-error *ngIf="labFormGroup.get('TaxId').invalid">
                    Cannot be longer than 10 characters.
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Accreditation Code</mat-label>
                  <mat-select formControlName="AcCredit">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let types of accList" [value]="types.key">{{types.value}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="labFormGroup.get('Closed').invalid">
                    Cannot be longer than 1 character
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Phone</mat-label>
                  <input matInput formControlName="PhoneNumber" placeholder="(000) 000-0000">
                  <mat-error *ngIf="labFormGroup.get('PhoneNumber').invalid">
                    Invalid phone number
                  </mat-error>
                </mat-form-field>
                <div>

                </div>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="flex flex-row flex-wrap gap-4 sm:flex-col w-1/2">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <div class="flex flex-col mt-4">

                <mat-form-field>
                  <mat-label>CLIA Number</mat-label>
                  <input matInput formControlName="CliaNumber">
                  <mat-error *ngIf="labFormGroup.get('CliaNumber').invalid">
                    This field is required (10 char max)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Certificate Exp Date</mat-label>
                  <input matInput formControlName="CliaCertificateExpiration">
                  <mat-error *ngIf="labFormGroup.get('CliaCertificateExpiration').invalid">
                    This field is required (numbers)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Last Survey Date</mat-label>
                  <input matInput formControlName="LastSurveyDate" readonly>
                  <mat-error *ngIf="labFormGroup.get('LastSurveyDate').invalid">

                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Complexity</mat-label>
                  <mat-select formControlName="Complexity">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let types of complexList" [value]="types.key">{{types.value}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="labFormGroup.get('Complexity').invalid">
                    Certificate Type cannot be longer than 1 character
                  </mat-error>
                </mat-form-field>

                <mat-form-field [ngStyle]="{'background-color': (labFormGroup.controls['CloseDate'].value != '') ? 'tomato' : ''}">
                  <mat-label>Closed Date</mat-label>
                  <input matInput formControlName="CloseDate">
                  <mat-error *ngIf="labFormGroup.get('CloseDate').invalid">

                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Accreditation Number</mat-label>
                  <input matInput placeholder="Accreditation Number" formControlName="Npi">
                  <mat-error *ngIf="labFormGroup.get('Npi').invalid">
                    Cannot be longer than 10 characters.
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Fax</mat-label>
                  <input matInput formControlName="FaxNumber" placeholder="(000) 000-0000">
                  <mat-error *ngIf="labFormGroup.get('FaxNumber').invalid">

                  </mat-error>
                </mat-form-field>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <span style="width: 100%;border-top: 1px solid grey"></span>

    <div class="flex flex-row gap-4">
      <div class="flex flex-row flex-wrap gap-4 sm:flex-col w-1/2">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <div class="flex flex-col mt-4">

                <mat-form-field>
                  <mat-label>Mailing Address</mat-label>
                  <input matInput formControlName="MailAddress">
                  <mat-error *ngIf="labFormGroup.get('MailAddress').invalid">
                    This field is required (10 char max)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Mail City</mat-label>
                  <input matInput formControlName="MailCity">
                  <mat-error *ngIf="labFormGroup.get('MailCity').invalid">
                    This field is required (numbers)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Mail State</mat-label>
                  <input matInput formControlName="MailState">
                  <mat-error *ngIf="labFormGroup.get('MailState').invalid">
                    Invalid State (2 char abbreviation only)
                  </mat-error>
                </mat-form-field>


                <mat-form-field>
                  <mat-label>Mail Zip</mat-label>
                  <input matInput formControlName="MailZip">
                  <mat-error *ngIf="labFormGroup.get('MailZip').invalid">
                    Invalid Zip Code
                  </mat-error>
                </mat-form-field>

                <div *ngIf="editMode">
                  <button type="button" mat-raised-button color="primary" (click)="copyAddress()">Copy Mailing to
                    Site</button>
                </div>
                
                <div *ngIf="!editMode" style="border-bottom: 16px;">
                  <a href="{{mapLink}}" target="_blank">
                  <button  type="button" mat-raised-button color="primary">
                    Map
                  </button>
                </a>
                </div>

                <mat-form-field>
                  <mat-label>Site Address </mat-label>
                  <input matInput formControlName="SiteAddress">
                  <mat-error *ngIf="labFormGroup.get('SiteAddress').invalid">
                    This field is required (10 char max)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Site City</mat-label>
                  <input matInput formControlName="SiteCity">
                  <mat-error *ngIf="labFormGroup.get('SiteCity').invalid">
                    This field is required (numbers)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Site State</mat-label>
                  <input matInput formControlName="SiteState">
                  <mat-error *ngIf="labFormGroup.get('SiteState').invalid">
                    Invalid State (2 char abbreviation only)
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Site Zip</mat-label>
                  <input matInput formControlName="SiteZip">
                  <mat-error *ngIf="labFormGroup.get('SiteZip').invalid">
                    Invalid Zip Code
                  </mat-error>
                </mat-form-field>

              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="flex flex-row flex-wrap gap-4 sm:flex-col w-1/2">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <div class="flex flex-col mt-4">

                <mat-form-field>
                  <mat-label>Director</mat-label>
                  <input matInput formControlName="Director">
                  <mat-error *ngIf="labFormGroup.get('Director').invalid">
                    Cannot be longer than 100 characters.
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Director Phone</mat-label>
                  <input matInput formControlName="DirectorPhone" placeholder="(000) 000-0000">
                  <mat-error *ngIf="labFormGroup.get('DirectorPhone').invalid">
                    Invalid Phone number
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Director Email</mat-label>
                  <input matInput formControlName="DirectorEmail">
                  <mat-error *ngIf="labFormGroup.get('DirectorEmail').invalid">
                    Cannot be longer than 100 characters.
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Manager</mat-label>
                  <input matInput formControlName="Manager">
                  <mat-error *ngIf="labFormGroup.get('Manager').invalid">
                    Cannot be longer than 100 characters.
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Manager Phone</mat-label>
                  <input matInput formControlName="ManagerPhone" placeholder="(000) 000-0000">
                  <mat-error *ngIf="labFormGroup.get('ManagerPhone').invalid">
                    Invalid Phone number
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Manager Email-SOA/HST Primary Email</mat-label>
                  <input matInput formControlName="ManagerEmail">
                  <mat-error *ngIf="labFormGroup.get('ManagerEmail').invalid">
                    Cannot be longer than 100 characters.
                  </mat-error>
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Lab Type</mat-label>
                  <mat-select formControlName="LabType">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let types of labTypeList" [value]="types.key">{{types.value}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="labFormGroup.get('LabType').invalid">
                    Cannot be longer than 2 characters.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <span style="width: 100%;border-top: 1px solid gray"></span>

    <div class="flex flex-col">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-col">
          <div class="flex flex-row flex-wrap gap-6 my-8" style="font-size:medium">
            <span style="font-weight:bold;">Associated Labs :</span>

            <mat-checkbox formControlName="Hst">HST</mat-checkbox>
            <mat-checkbox formControlName="Soa">SOA</mat-checkbox>
            <mat-checkbox formControlName="Shared">Shared</mat-checkbox>
            <mat-checkbox formControlName="Multiple">Multiple</mat-checkbox>
            <mat-checkbox formControlName="Lrn">Sentinel (LRN)</mat-checkbox>
            <mat-checkbox formControlName="OutOfState">Out of State</mat-checkbox>
            <mat-checkbox formControlName="CovidLab">Covid Lab</mat-checkbox>

          </div>

          <span style="width: 100%;border-top: 1px solid grey"></span>

          <div class="flex flex-row gap-4">
            <div class="flex flex-row flex-wrap sm:flex-col w-1/2">
              <mat-card-content class="w-full">
                <div class="flex flex-col mt-4 w-full">

                  <mat-form-field>
                    <mat-label>Office Hours</mat-label>
                    <mat-select formControlName="OfficeHours">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let types of hoursList" [value]="types.key">{{types.value}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="labFormGroup.get('OfficeHours').invalid">
                      Cannot be longer than 2 characters.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>County Code</mat-label>
                    <mat-select formControlName="CountyCode">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let types of countyList" [value]="types.key">{{types.value}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="labFormGroup.get('CountyCode').invalid">
                      Cannot be longer than 2 characters.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Office HR Comments</mat-label>
                    <textarea matInput cdkTextareaAutosize formControlName="OfficeComments"></textarea>
                    <mat-error *ngIf="labFormGroup.get('OfficeComments').invalid">
                      Cannot be longer than 4000 characters.
                    </mat-error>
                  </mat-form-field>

                </div>
              </mat-card-content>
            </div>
            <div class="flex flex-row flex-wrap sm:flex-col w-1/2">
              <mat-card-content class="w-full gap-4">
                <div class="flex flex-col mt-4">

                  <mat-form-field>
                    <mat-label>Ownership Type</mat-label>
                    <mat-select formControlName="OwnerType">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let types of ownershipList" [value]="types.key">{{types.value}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="labFormGroup.get('OwnerType').invalid">
                      Cannot be longer than 2 characters.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Shared/Multiple Info</mat-label>
                    <input matInput formControlName="SharedMulitText">
                    <mat-error *ngIf="labFormGroup.get('SharedMulitText').invalid">
                      
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field *ngIf="type =='30'">
                    <mat-label>SOA Kit</mat-label>
                    <input matInput formControlName="SoaKit">
                    <mat-error *ngIf="labFormGroup.get('SoaKit').invalid">
                      Invalid Kit.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field *ngIf="type =='30'">
                    <mat-label>SOA Kit Year</mat-label>
                    <input matInput formControlName="SoaYear">
                    <mat-error *ngIf="labFormGroup.get('SoaYear').invalid">
                      Invalid Year
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Comments</mat-label>
                    <textarea matInput cdkTextareaAutosize formControlName="Comments"></textarea>
                    <mat-error *ngIf="labFormGroup.get('Comments').invalid">
                      Cannot be longer than 4000 characters.
                    </mat-error>
                  </mat-form-field>

                </div>
              </mat-card-content>
            </div>
          </div>
        </div>
      </mat-card>

    </div>
  </kendo-pdf-export>
    <div class="flex flex-row">
      <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
            'bg-gray-700': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
        <div class="flex flex-row">
          <div class="flex flex-row gap-4 w-full">
            <div>
              <span style="font-weight:bold;">Created By: </span>
              <span>{{createdBy}} on {{createDate}}</span>
              <br />
              <span style="font-weight:bold;">Last Updated by: </span>
              <span>{{updatedBy}} on {{updateDate}}</span>
            </div>
            <div>
              <span *ngIf="editMode" class="oha-blue-bg p-x-48 text-light">Edit Mode</span>
            </div>
          </div>

          <div class="flex flex-row float-right">
            <button mat-icon-button *ngIf="!editMode && !labService.readonly" matTooltip="Edit" (click)="editLab()"
              [matTooltipShowDelay]="750">
              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">edit</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!isDirty && editMode" matTooltip="Save"
              (click)="saveLabDemographics()" [matTooltipShowDelay]="750">
              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
            </button>
            <button mat-icon-button *ngIf="editMode" matTooltip="Cancel" (click)="cancelLab()"
              [matTooltipShowDelay]="750">
              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
            </button>
          </div>
        </div>

      </mat-card>
    </div>
  </div>
</form>
<!-- <div class="row">{{demog | json}}</div> -->